export const DataConstant = {
    get toastifyMessages() {
        return (
            {
                SUCCESS: {
                    ORDER_PLACED: "Your order has been placed successfully! Thank you for shopping with us.",
                    ORDER_CANCELED: "Order canceled successfully.",
                    CART_ITEM_ADDED: "Item added to your cart successfully!",
                    CART_ITEM_REMOVED: "Item removed from your cart successfully!",
                    CART_UPDATED: "Your cart has been updated!",
                    PAYMENT_SUCCESSFUL: "Payment completed successfully! Your order is on the way.",
                    PAYMENT_METHOD_ADDED: "Payment method added successfully!",
                    ACCOUNT_CREATED: "Welcome! Your account has been created successfully.",
                    PROFILE_UPDATED: "Your profile has been updated successfully.",
                    PASSWORD_CHANGED: "Password changed successfully!",
                    WISHLIST_ITEM_ADDED: "Item added to your wishlist!",
                    WISHLIST_ITEM_REMOVED: "Item removed from your wishlist.",
                    REVIEW_SUBMITTED: "Thank you for your feedback! Your review has been submitted.",
                    SUBSCRIPTION_SUCCESSFUL: "You’ve successfully subscribed to our newsletter!",
                    NEW_ADDRESS_ADD_SUCCESSFULLY:"Address added successfully",
                    UPDATE_ADDRESS_SUCCESSFULLY:"Update address successfully",
                    LOGOUT_SUCCESSFULLY:"Logout successfully",
                    LOGIN_SUCCESSFULLY:"Login successfully",
                    OTP_SEND_SUCCESSFULLY:'OTP sent successfully',
                    FORM_SUBMIT_SUCCESSFULLY:'Form submit successfully'
                },
                ERROR: {
                    SELECT_PRODUCT_SIZE: "Please select product size",
                    ORDER_FAILED: "Failed to place your order. Please try again.",
                    ORDER_CANCELLATION_FAILED: "Order cancellation failed. Please contact support.",
                    CART_ITEM_ADD_FAILED: "Failed to add item to your cart. Please try again.",
                    CART_UPDATE_FAILED: "Failed to update cart. Please refresh the page and try again.",
                    PAYMENT_FAILED: "Payment failed! Please try again or use a different payment method.",
                    PAYMENT_PROCESSING_FAILED: "Unable to process your payment. Please check your card details.",
                    PROFILE_UPDATE_FAILED: "Failed to update your profile. Please try again.",
                    LOGIN_FAILED: "Login failed! Please check your credentials and try again.",
                    WISHLIST_ITEM_ADD_FAILED: "Failed to add item to your wishlist. Please try again.",
                    WISHLIST_ITEM_REMOVE_FAILED: "Failed to remove item from your wishlist. Please refresh and try again.",
                    GENERAL_ERROR: "Something went wrong! Please try again later.",
                    CONTENT_LOAD_FAILED: "Failed to load content. Please check your internet connection.",
                    FILE_UPLOAD_FAILED: "Failed to upload the file. Please ensure it meets the required format.",
                },
                WARNING: {
                    ORDER_DELAY_WARNING: "Your order might be delayed due to high demand.",
                    CART_EXPIRATION_WARNING: "Your cart will expire in 10 minutes. Complete your purchase soon!",
                    LOW_STOCK_WARNING: "Hurry! Only a few items left in stock.",
                    SESSION_EXPIRATION_WARNING: "Your session is about to expire. Please log in again.",
                    UNSAVED_CHANGES_WARNING: "You have unsaved changes. Are you sure you want to leave this page?",
                    PAYMENT_DETAILS_WARNING: "Please check your payment details before proceeding.",
                    COUPON_EXPIRATION_WARNING: "This coupon is about to expire! Use it soon.",
                    ONE_COUPON_LIMIT_WARNING: "Only one coupon can be applied at a time.",
                    PLEASE_LOGIN_FIRST:'Please login for shopping',
                    PRODUCT_QUANTITY_EXCEED: 'You can add up to 10 items only.'
                },
                INFO: {
                    ORDER_OUT_FOR_DELIVERY: "Your order is out for delivery and will arrive soon!",
                    ORDER_SHIPPED: "Order shipped! Track your package in your account.",
                    CART_ITEMS_AVAILABLE: "Saved items are still available in your cart.",
                    MAX_QUANTITY_LIMIT: "You can only purchase a maximum of 5 units of this item.",
                    PROMO_INFO: "Buy 1, get 1 free on select items! Limited time offer.",
                    FREE_SHIPPING_INFO: "Free shipping on orders above $50!",
                    DELIVERY_ESTIMATE: "Expected delivery: 3–5 business days.",
                    PASSWORD_UPDATE_INFO: "Your account password has been updated recently.",
                    SESSION_INFO: "Stay logged in to avoid session timeout.",
                    SUPPORT_QUERY_SUBMITTED: "Your query has been submitted! Our support team will get back to you shortly.",
                    SUPPORT_CHAT_AVAILABLE: "Chat support is available. Start a conversation now!",
                    SUBSCRIPTION_INFO: "You’ve successfully subscribed to our newsletter!",
                },
            }
        )
    },
    get serviceStatus() {
        return {
            SUCCESS:'success',
            FAIL:'fail',
            LOADING:'loading',
            NONE:'none'
        }
    },
    get httpStatus(){
        return{
            SUCCESS:'200',
            ERROR:'500'
        }
    },
    get sessionStorage(){
        return{
            JWT_TOKEN:"U2FsdGVkX19fBsh0pFjU3Y0ppJ0g4Wg2sPUo+te/ynIaiytbEn/xGe2UE2Puhj+N",
            USER_RESPONSE:"U2FsdGVkX19brIh5aMQLiRrUn69XGMqY5HBGX1rkYPm2QE7cHnebnCGCR00FnjbXgtmCE5hIcoexnRma012JQA==",
            LOGIN_RESPONSE:"U2FsdGVkX1+lVNywPTNgMxvhMzLLeWs8rHvxfuQxFZbUXxGqR7wC+r1KorwZB+fZflfc70y882k97582pqs2Ow==",
            PAYLOAD:"U2FsdGVkX186b/Y7txEvHu3ly9rnhw3FT753o9Mm4f7JRK4gVQ7g8pJfzIHDzp8R",
            PAGE_TRACKER:'U2FsdGVkX1/fYkZwit3TPEATSoOHHX82p9AVbNiGX6UQ6t6OhB5LcTfmWh/H9txz'
        }
    },
    get myOrderFilterValues(){
        return [
            {
                value:'All',
                key:'ALL'
            },
            {
                value:'Pending',
                key:'PENDING'
            },
            {
                value:'Cancelled',
                key:'CANCELLED'
            },
            {
                value:'Delivered',
                key:'DELIVERED'
            },
            {
                value:'Last 30 Days',
                key:'LAST_30_DAYS'
            },
            {
                value:'Last 3 Months',
                key:'LAST_3_MONTHS'
            }
        ]
    }

}